import { useState, useEffect } from "react"
import api from '../../utils/api'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

import FormInvoice from './Form/FormInvoice'

// Conteúdo embutido num Modal (ver Fiscal.js e ListOrderRow.js) — a permissão de
// emitir já é checada pelo componente pai antes de mostrar o gatilho que abre isso.
function NewInvoice({ orderId, btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const [prefill, setPrefill] = useState(null)
    const [load, setLoad] = useState(!orderId)
    const [formErrors, setFormErrors] = useState([])

    useEffect(() => {
        if (!orderId) return
        api.get(`/fiscal/invoice/prefill/${orderId}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            setPrefill(response.data)
            setLoad(true)
        }).catch(() => {
            setLoad(true)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, orderId])

    async function submit(data) {
        setFormErrors([])
        let msgType = 'success'
        const response = await api.post('/fiscal/invoice/emit', data, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((res) => {
            return res.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(response.message, msgType)
        if (msgType === 'error') {
            setFormErrors(response.errors || [])
            return
        }

        handleOnSuccess()
    }

    if (!load) {
        return <div className="pg-loading">Carregando dados do pedido...</div>
    }

    return (
        <FormInvoice
            title="Nova Nota Fiscal"
            initialData={prefill}
            handleSubmit={submit}
            formErrors={formErrors}
            btCancelAction={btCancelAction}
        />
    )
}

export default NewInvoice
